import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { acceso360Client } from '@/lib/axios';
import { IamBackend } from '@/lib/BackendUrls';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { User, UsersParams } from '../types/types';

import { userQueryKeys } from './query-keys';

export type GetUsersResponse = User[];

export function getUsers(params?: UsersParams): Promise<GetUsersResponse> {
  return acceso360Client
    .get(IamBackend.users.self, {
      params,
    })
    .then(({ data }) => data);
}
type QueryFnType = typeof getUsers;

interface UseUsersParams {
  config?: QueryConfig<QueryFnType>;
  params?: UsersParams;
}

export function useUsers({ config = {}, params = {} }: UseUsersParams = {}) {
  const queryOptions: UseQueryOptions<ExtractFnReturnType<QueryFnType>, Error> = {
    ...config,
    queryKey: userQueryKeys.list(params),
    queryFn: () => getUsers(params),
    staleTime: 300000, // 5 minutos
    gcTime: 900000, // 15 minutos
  };

  return useQuery<ExtractFnReturnType<QueryFnType>>(queryOptions);
}
